// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"1783578794735"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import { init, replayIntegration, browserApiErrorsIntegration} from '@sentry/nextjs'
import { shouldSkipReplayForError } from './utils/sentry-errors'

init({
	dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
	debug: false,
	tracesSampleRate: 0,
	integrations: (integrations) => {
		return [
			...integrations.map((integration) => {
				if (integration.name === 'BrowserApiErrors') {
					return browserApiErrorsIntegration({
						eventTarget: false,
					})
				}
				return integration
			}),
			replayIntegration({
				maskAllText: false,
				maskAllInputs: false,
				blockAllMedia: false,
				beforeErrorSampling: (event) => {
					// Skip replay quota for known non-actionable / diagnostic events.
					return !shouldSkipReplayForError(event)
				},
			}),
		]
	},
	replaysOnErrorSampleRate: 1.0,
	replaysSessionSampleRate: 0,
	environment: process.env.NEXT_PUBLIC_SENTRY_ENV,
	ignoreErrors: [
		'ResizeObserver loop limit exceeded',
		'ResizeObserver loop completed with undelivered notifications.',
		"Can't find variable: _AutofillCallbackHandle",
		'getRestrictions is not a function',
		"Can't find variable: fbq",
		'fbq is not defined',
		'Non-Error promise rejection captured with value: Object Not Found',
		'Non-Error exception captured',
		'Error: ib',
		"Cannot read properties of null (reading 'readyState')",
	],
	beforeSend(event, hint) {
		if (
			event.exception?.values?.[0].type === 'Error' &&
			event.exception?.values?.[0]?.value?.includes(
				'Unable to find `next-intl` locale'
			)
		) {
			return null
		}

		// Check for bot user agents
		const userAgent = event.request?.headers?.['User-Agent'] || ''

		// Check for specific problematic user agents
		if (
			userAgent.includes('Google-Read-Aloud') ||
			(userAgent.includes('Android 7.0') && userAgent.includes('Chrome/59'))
		) {
			return null
		}

		return event
	},
})
